import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../lib/msalConfig";
import { useAuthProvider } from "../../hooks/use-azure-auth-provider";

interface AuthButtonProps {
  className?: string;
}

export const AzureSignInButton: React.FC<AuthButtonProps> = ({ className }) => {
  const { instance } = useMsal();
  
  const handleSignIn = async () => {
    try {
      console.log('Starting MSAL login flow...');
      // Use popup for better user experience
      const result = await instance.loginPopup(loginRequest);
      console.log('Login successful:', result.account?.username);
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <button 
      onClick={handleSignIn}
      className={className || "btn btn-primary"}
    >
      Sign in with Microsoft
    </button>
  );
};

export const AzureSignOutButton: React.FC<AuthButtonProps> = ({ className }) => {
  const { isSignedIn } = useAuthProvider();
  const { instance } = useMsal();
  
  const handleSignOut = async () => {
    try {
      console.log('Starting MSAL logout flow...');
      await instance.logoutPopup({
        postLogoutRedirectUri: window.location.origin,
      });
      console.log('Logout successful');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  if (!isSignedIn) {
    return null;
  }

  return (
    <button 
      onClick={handleSignOut}
      className={className || "btn btn-outline"}
    >
      Sign Out
    </button>
  );
};